import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadProductConfigs } from 'src/redux/actions/productConfigActions';
import { ProductConfig } from 'src/redux/reducers/productConfigReducer';
import { RootState } from 'src/redux/reducers/rootReducer';
export const useProductConfigs = () => {
  const dispatch = useDispatch();
  const auth = useSelector((state: RootState) => state.auth);

  const { data, isLoading } = useSelector(
    (state: RootState) => state.productConfigs,
  );

  useEffect(() => {
    if (!auth.isSessionExpired) dispatch(loadProductConfigs());
  }, [auth.isSessionExpired, dispatch]);

  const getProductConfig = (service: string, parameter: string) => {
    return data.find(
      (config: ProductConfig) =>
        config.service === service && config.parameter === parameter,
    )?.value;
  };

  return { data, isLoading, getProductConfig };
};
